<template>
  <mission-detail-section
    class="mission-detail-vehicle-section"
  >
    <template
      #title
    >
      <mission-detail-section-title
        :title="$tc('app.labels.specificities.title', 2) | capitalize"
      >
        <ui-ctk-icon
          name="hatch"
          class="tw-text-blue-500 tw-text-3xl"
        />
      </mission-detail-section-title>
    </template>

    <div class="mission-detail-vehicle-section__items tw-flex tw-flex-wrap tw-mb-6">
      <!-- type -->
      <mission-detail-group-item
        :title="$tc('app.labels.vehicle_detail.title', 2) | capitalize"
        v-if="mission.vehicle_types.length"
        data-test="vehicle-types"
      >
        <span
          v-for="(vehicle, index) in mission.vehicle_types"
          :key="'vehicle-' + index"
        >
          {{ vehicle.label | capitalize }}<span v-if="index < mission.vehicle_types.length - 1">,&nbsp;</span>
        </span>
      </mission-detail-group-item>
      <!-- Equipments -->
      <mission-detail-group-item
        :title="$tc('app.labels.equipment.title', 2) | capitalize"
        v-if="mission.equipments && mission.equipments.length"
        data-test="equipments"
        class="tw-pl-4"
      >
        <span
          v-for="(equipment, index) in mission.equipments"
          :key="'equipment-' + index"
        >
          {{ equipment.label | capitalize }}<span v-if="index < mission.equipments.length - 1">,&nbsp;</span>
        </span>
      </mission-detail-group-item>
    </div>
  </mission-detail-section>
</template>

<script>
  import { defineComponent } from '@vue/composition-api'

  import MissionDetailSection from '@/views/Carriers/Missions/views/_subs/MissionDetail/components/MissionDetailSection'
  import MissionDetailSectionTitle from '@/views/Carriers/Missions/views/_subs/MissionDetail/components/MissionDetailSection/MissionDetailSectionTitle/index.vue'
  import MissionDetailGroupItem from '@/views/Carriers/Missions/views/_subs/MissionDetail/components/MissionDetailGroupItem/index.vue'

  /**
   * @module component - MissionDetailVehicleSection
   */
  export default defineComponent({
    name: 'MissionDetailVehicleSection',
    components: {
      MissionDetailSection,
      MissionDetailSectionTitle,
      MissionDetailGroupItem
    },
    props: {
      mission: {
        type: Object,
        required: true
      }
    }
  })
</script>

<style lang="scss" scoped>.mission-detail-vehicle-section {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  position: relative;
}
.mission-detail-vehicle-section::after {
  --tw-bg-opacity: 1;
  background-color: rgba(227, 227, 229, var(--tw-bg-opacity));
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 1px;
}
.mission-detail-vehicle-section__items {
  margin: -1rem;
}
.mission-detail-vehicle-section__items .mission-detail-group-item {
  margin: 1rem;
  position: relative;
  flex: 1 0 calc(45% - 2rem);
}
@media (min-width: 770px) {
  .mission-detail-vehicle-section__items .mission-detail-group-item {
    flex: 1 0 calc(18% - 1rem);
  }
  .mission-detail-vehicle-section__items .mission-detail-group-item:not(:last-child) {
    position: relative;
  }
  .mission-detail-vehicle-section__items .mission-detail-group-item:not(:last-child)::after {
    --tw-border-opacity: 1;
    border-color: rgba(214, 214, 218, var(--tw-border-opacity));
    border-style: solid;
    border-top-width: 1px;
    border-left-width: 1px;
    border-bottom-width: 1px;
    border-right-width: 0px;
    height: 100%;
    position: absolute;
    content: '';
    width: 1px;
    right: -1rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
.mission-detail-vehicle-section .mission-detail-specificity-group {
  margin-bottom: 0px;
}</style>
